/**
 * Rightsizing feature identity (design v7, §5.2).
 *
 * Imported by both sides; the name/key facts exist once. Single-key module:
 * every registration and route attributes implicitly.
 */

import { defineIdentity, type FeatureIdentity } from '../featureModule'

export const identity: FeatureIdentity = defineIdentity({
  name: 'rightsizing',
  entitlements: ['rightsizing'],
})

/**
 * Integration keys that can serve rightsizing metrics.
 *
 * Shared because two sides need the same answer and must not drift: the worker
 * assembles a source adapter per key, and the navigation decides whether
 * Rightsizing has anything to analyse. Adding Zabbix or Datadog later means
 * adding a key here and an adapter beside it — the navigation is not touched.
 *
 * These are entitlement keys, which is what the configured-integration summary
 * is keyed by; a source whose key is not an integration key would be invisible
 * to that gate.
 */
export const METRICS_SOURCE_KEYS = Object.freeze(['checkmk'])
